import { core, map as mapEndpoints } from '@/api/api-endpoints'
import MapPopup from '@/utils/map/popup/MapPopup'
import * as L from 'leaflet'
import { getMSNIcon, getGarbageIcon } from '@/utils/map/icon'

const menuGroups = {
  oth_with_mno: {
    iconType: 'organization',
    label: 'Имеющие привязку',
    color: 'wasteCreators',
  },
  oth_without_mno: {
    iconType: 'organization',
    label: 'Не имеющие привязку',
    color: 'wasteCreators',
  },
  container: {
    iconType: 'container',
    label: 'Контейнерные площадки',
    color: 'places',
  },
  model: {
    iconType: 'modeling',
    label: 'Модельные контейнерные площадки',
    color: 'places',
  },
}

function getGarbageFlatData(values, type) {
  const flatData = []
  const data = []
  data.push(Object.values(values))
  data.forEach((el) => {
    el.forEach((element) => {
      element.forEach((i) => {
        flatData.push({ ...i, [type]: true })
      })
    })
  })
  return flatData
}

export default {
  data: () => ({
    mnoLayers: [],
    mnoMapLayers: null,
    modelContainerId: null,
    flatData: null,
    clusterClassName: 'cluster-marker',
  }),
  computed: {
    mnoLayersConf() {
      return this.getLayersConf()
    },
  },
  watch: {
    mnoLayers() {
      if (this.mnoMapLayers) {
        this.map.removeLayer(this.mnoMapLayers)
      }
      if (this.mnoLayers.length) {
        this.getMnoObjects()
      }
    },
  },
  methods: {
    async getMsnTypeCollection() {
      const data = await (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: core.collection('msn_type'),
        })
      ).data.msn_type
      this.modelContainerId = data.find(
        (item) => item.code === 'with_containers_model'
      ).id
    },
    getLayersConf() {
      return {
        gs: {
          menuClass: 'oth',
          label: 'Отходообразователи',
          mnoEndpoints: [
            mapEndpoints.sourceHasMsnRel,
            mapEndpoints.sourceWithoutMsnRel,
          ],
          className: 'cluster-marker oth',
          iconType: 'wasteCreators',
          groups: {
            oth_with_mno: menuGroups.oth_with_mno,
            oth_without_mno: menuGroups.oth_without_mno,
          },
        },
        msn: {
          iconType: 'places',
          menuClass: 'places',
          label: 'Места сбора и накопления',
          endpoint: mapEndpoints.msn,
          className: 'cluster-marker msn',
          groups: {
            container: menuGroups.container,
            model: menuGroups.model,
          },
        },
      }
    },
    toggleClusters() {
      if (this.mnoMapLayers) {
        this.map.removeLayer(this.mnoMapLayers)
      }
      if (this.mnoLayers.length) {
        this.getMnoObjects()
      }
    },
    onMnoLayersChange(item, name, rootGroupName) {
      if (this.mnoMapLayers) {
        this.map.removeLayer(this.mnoMapLayers)
      }
      if (item.hasOwnProperty('groups')) {
        let parentExist = this.mnoLayers.indexOf(name) > -1
        for (let groupItemName in item.groups) {
          if (parentExist && this.mnoLayers.indexOf(groupItemName) === -1) {
            this.mnoLayers.push(groupItemName)
          }
          if (!parentExist && this.mnoLayers.indexOf(groupItemName) > -1) {
            this.mnoLayers = this.mnoLayers.filter((v) => v !== groupItemName)
          }
        }
      } else {
        let itemExist = this.mnoLayers.indexOf(name) > -1
        if (!itemExist) {
          this.mnoLayers = this.mnoLayers.filter((v) => v !== rootGroupName)
        } else {
          if (this.mnoLayersConf[rootGroupName]) {
            let allChecked = true
            for (let groupItemName in this.mnoLayersConf[rootGroupName]
              .groups) {
              if (this.mnoLayers.indexOf(groupItemName) === -1) {
                allChecked = false
              }
            }
            if (allChecked === false) {
              this.mnoLayers = this.mnoLayers.filter((v) => v !== rootGroupName)
            } else if (this.mnoLayers.indexOf(rootGroupName) === -1) {
              this.mnoLayers.push(rootGroupName)
            }
          }
        }
      }
      setTimeout(
        () => this.replaceRoute({ mnoLayers: this.mnoLayers }, false),
        50
      )
    },
    async getMnoObjects() {
      this.$store.dispatch('showPreloader')
      this.mnoMapLayers = L.featureGroup()
      await this.getData()
      Object.entries(this.flatData).forEach(([key, value]) => {
        const cluster = this.clusterEnabled
          ? L.markerClusterGroup({
              iconCreateFunction: (cluster) =>
                L.divIcon({
                  className: `${this.clusterClassName} ${key}`,
                  html: cluster.getChildCount(),
                  iconSize: [36, 36],
                  iconAnchor: [18, 18],
                }),
            })
          : L.featureGroup()
        value.forEach((element) => {
          const marker = this.prepareMarker(element)
          cluster.addLayer(marker)
        })
        this.mnoMapLayers.addLayer(cluster)
      })

      this.map.addLayer(this.mnoMapLayers)
      this.$store.dispatch('hidePreloader')
    },
    async getData() {
      let oth_with_mno = []
      let oth_without_mno = []
      let msn_container = []
      let msn_model = []
      if (this.mnoLayers.includes('oth_with_mno')) {
        oth_with_mno = await (
          await this.$store.dispatch('updateUrlEndpoint', {
            endpoint: mapEndpoints.sourceHasMsnRel(),
            fromCache: false,
            notReactive: false,
          })
        ).data
        oth_with_mno = getGarbageFlatData(oth_with_mno, 'oth_with_mno')
      }

      if (this.mnoLayers.includes('oth_without_mno')) {
        oth_without_mno = await (
          await this.$store.dispatch('updateUrlEndpoint', {
            endpoint: mapEndpoints.sourceWithoutMsnRel(),
            fromCache: false,
            notReactive: false,
          })
        ).data
        oth_without_mno = getGarbageFlatData(oth_without_mno, 'oth_without_mno')
      }
      if (
        this.mnoLayers.includes('model') ||
        this.mnoLayers.includes('container')
      ) {
        const data = await (
          await this.$store.dispatch('updateUrlEndpoint', {
            endpoint: mapEndpoints.msn(),
            fromCache: false,
            notReactive: false,
          })
        ).data
        Object.values(data).forEach((item) => {
          item.forEach((el) => {
            if (
              el.type === this.modelContainerId &&
              this.mnoLayers.includes('model')
            ) {
              msn_model.push({ ...el, isMsnModel: true })
            }
            if (
              el.type !== this.modelContainerId &&
              this.mnoLayers.includes('container')
            ) {
              this.clusterClassName = 'cluster-marker msn_container'
              msn_container.push({ ...el, isMsnContainer: true })
            }
          })
        })
      }

      this.flatData = {
        oth_with_mno,
        oth_without_mno,
        msn_container,
        msn_model,
      }
    },
    prepareMarker(element) {
      const latLng = L.latLng(Number(element.lat), Number(element.lng))
      let endpointForMarkers = null
      let iconType = null

      let className = `map-icon  ${element.status_code}`
      if (element.oth_with_mno) {
        endpointForMarkers = mapEndpoints.sourceById(element.id)
        iconType = getGarbageIcon(element.garbage_source_type_id)
        className += ' map-icon_organization map-icon_oth_with_mno'
      }
      if (element.oth_without_mno) {
        iconType = getGarbageIcon(element.garbage_source_type_id)
        endpointForMarkers = mapEndpoints.sourceById(element.id)
        className += ' map-icon_organization map-icon_oth_without_mno'
      }
      if (element.isMsnModel) {
        endpointForMarkers = mapEndpoints.msnById(element.id)
        iconType = getMSNIcon(element.type)

        className += ' map-icon_places map-icon_modeling'
      }
      if (element.isMsnContainer) {
        endpointForMarkers = mapEndpoints.msnById(element.id)
        iconType = getMSNIcon(element.type)
        className += ' map-icon_container'
      }
      const myIcon = L.divIcon({
        className: 'my-div-icon',
        html: `<div class='${className}'><span class='map-icon__point'></span></div>`,
      })

      const marker = L.marker(latLng, {
        icon: myIcon,
      })

      const popup = new MapPopup({
        id: element.id,
        className: 'popup--fixing',
        layerConfig: { endpoint: endpointForMarkers },
        subLayerConfig: {
          iconType,
        },
        onClose: () => {
          if (this.msnDetailLayer) {
            this.$store.dispatch('msnDetailsOn', false)
            this.map.removeLayer(this.msnDetailLayer)
          }
        },
      })

      marker.bindPopup(popup)
      return marker
    },
  },
  created() {
    if (this.$route.query.mnoLayers) {
      this.mnoLayers = this.$route.query.mnoLayers.split(',')
    }
    this.getMsnTypeCollection()
  },
}
